
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { AwsAmplifyService } from '../shared/services/aws/awsAmplify.service';
import { CloudService } from '../shared/services/cloud.service';
import { errorMessages } from '../shared/helpers/errorMessages';
import { ApiprocedureService } from '../shared/java/apiprocedure.service';
import { environment } from 'src/environments/environment';
import { ApiHttpService } from '../api-http.service';
import { constantStrings } from '../shared/helpers/constants';
export interface ChallengeParameters {
    CODE_DELIVERY_DELIVERY_MEDIUM: string;

    CODE_DELIVERY_DESTINATION: string;
}
@Injectable()
export class UserManagementService {
    public userLoginResponse: any;
    public userloginErrRes: any;
    private updateUserSessionAPI_clp : string = environment.baseUrlClp + '/clp/updateSessionDateAndFlag';
    private updateUserSessionAPI_snnclp: string = environment.baseUrlClpSnn + '/adminclp/updateSessionDateAndFlag';
    constructor(
        private router: Router,
        private http: ApiHttpService,
        private cloudService: CloudService,
        private aws: AwsAmplifyService,
        private logService: ApiprocedureService
    ) {

    }
    public userlogin(userName: string, password: string, callback: any): any {
        this.cloudService.login(userName, password, async (err: any, result: any) => {
            if (err) {
                this.userloginErrRes = err;
                return callback(err, null);
            }
            if (result) {
                this.userLoginResponse = result
                return callback(null, result);
            }
        });
    }

    public fetchTokenCode(code: string, vId, baseState, callback: any): any {
        this.logService.fetchTokenCode(code, vId, baseState).subscribe(
            (response) => {
                return callback(null, response);
            },
            (error) => {
                return callback(error, null);
            }
        );
    }

    public getCognitoId(callback) {
        this.aws.getIdToken()
            .subscribe(
                (response) => {
                    return callback(null, response);
                },
                (errorCognitoId) => {
                    if (errorCognitoId !== null && errorMessages[errorCognitoId.code]) {
                        errorCognitoId.message = errorMessages[errorCognitoId.code];
                    }
                    return callback(errorCognitoId, null);
                }
            );
    }

    /**
        * @description To update user session
        * @memberof UserManagementService
        * @returns this will call update user session
        */
    public updateUserSession(currentTime, redirectedFrom): any {
        if (redirectedFrom === constantStrings.hostedUICLP) {
            return this.http.put(this.updateUserSessionAPI_clp + '?currenttime=' + currentTime, currentTime);
        } else if (redirectedFrom === constantStrings.hostedUISNN) {
            return this.http.put(this.updateUserSessionAPI_snnclp + '?currenttime=' + currentTime, currentTime);
        }
    }
}
